// BOTH REGISTRIES OR NEITHER -- see ReportResultEnterpriseComponentMetadata. Trimmed to match
// the class factory beside it; the two disagreeing is how you get `new undefined()`.
import DashboardEnterpriseComponentMetadata from "./ec/impl/Reporting/DashboardEnterpriseComponentMetadata";
import ReportResultEnterpriseComponentMetadata from "./ec/impl/Reporting/ReportResultEnterpriseComponentMetadata";

const enterpriseComponentMetadataClasses: Map<string, object> = new Map();
// BOTH registries are required. This one and EnterpriseComponentClassFactory; registering only
// one gives a blank page rather than a missing feature.
// BOTH REGISTRIES OR NEITHER -- see the note in the metadata file. Leaves with the tree.
enterpriseComponentMetadataClasses.set("ReportResultEnterpriseComponentMetadata", ReportResultEnterpriseComponentMetadata);
enterpriseComponentMetadataClasses.set("DashboardEnterpriseComponentMetadata", DashboardEnterpriseComponentMetadata);

export default function enterpriseObjectMetadataClassFactory(name: string): Object | undefined {
    return enterpriseComponentMetadataClasses.get(name + "EnterpriseComponentMetadata");
}